"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[221],{

/***/ 70341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SimpleStyledLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18518);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var _styled_system_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37947);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  text-decoration: none;\n  transition: color 0.3s;\n  ",
        "\n  &,\n  &:visited {\n    ",
        "\n  }\n\n  &:hover {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: none;\n  ",
        "\n  transition: background-color .3s;\n  > svg {\n    ",
        "\n  }\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: -1px;\n    left: -1px;\n    right: 0;\n    width: calc(100% + 2px);\n    height: 4px;\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 30%;\n  text-decoration: none;\n  border-radius: 1px;\n  border-width: 1px;\n  border-style: solid;\n  background-color: transparent;\n  transition: background-color 0.3s;\n  min-width: 165px;\n  ",
        "\n  &:hover {\n    ",
        "\n  }\n  > svg {\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/* Styles */ var SimpleStyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].a(_templateObject(), function(props) {
    return props.$inlineBlock ? 'inline-block' : 'block';
}, (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    marginY: '200'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    color: 'gray.900'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    color: 'blue.700'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    fontWeight: 'normal',
    textDecoration: 'underline'
}));
var BlueStyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].a(_templateObject1(), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    paddingY: '200',
    paddingX: '400',
    marginRight: '200'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    marginRight: '200'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    backgroundColor: 'blue.200'
}));
var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu)(_templateObject2(), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    backgroundColor: 'blue.700'
}));
var BoxStyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].a(_templateObject3(), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    color: 'gray.900',
    paddingX: '450',
    paddingY: '300',
    borderColor: 'gray.900',
    marginBottom: '500',
    fontSize: '200',
    lineHeight: '200'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    backgroundColor: 'gray.300',
    color: 'gray.900'
}), (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
    marginRight: '300'
}));
/* Components */ var SectionContent = function(props) {
    var title = props.title, desc = props.desc, desc2 = props.desc2;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                fontWeight: "semibold",
                fontSize: "500",
                lineHeight: "500",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                my: "300",
                mb: !desc2 ? '550' : '300',
                children: desc
            }),
            desc2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                mb: "550",
                children: desc2
            })
        ]
    }));
};
var GuideLink = function(props) {
    var url = props.url, text = props.text;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SimpleStyledLink, {
            children: text
        })
    }));
};
var Card = function(props) {
    var url = props.url, title = props.title, desc = props.desc, linkText = props.linkText;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledCard, {
            p: "16px 20px",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "gray.300",
            width: [
                '100%',
                '48%',
                '31%'
            ],
            position: "relative",
            minWidth: "175px",
            my: [
                '500',
                null,
                '200'
            ],
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    fontWeight: "semibold",
                    fontSize: "400",
                    lineHeight: "400",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    fontSize: "300",
                    lineHeight: "300",
                    my: "200",
                    children: desc
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SimpleStyledLink, {
                    children: linkText
                })
            ]
        })
    }));
};
var Library = function(props) {
    var Icon = props.Icon, name = props.name, url = props.url;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(BoxStyledLink, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {}),
                " ",
                name
            ]
        })
    }));
};
var HelpLink = function(props) {
    var Icon = props.Icon, text = props.text, url = props.url;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(BlueStyledLink, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {}),
                " ",
                text
            ]
        })
    }));
};
var BaseHomePageContent = function(props) {
    var gettingStarted = props.gettingStarted, migrationGuides = props.migrationGuides, clientLibraries = props.clientLibraries, help = props.help;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Stack */ .Kq, {
            space: "200",
            children: [
                gettingStarted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                        px: "800",
                        pt: "800",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                as: "h1",
                                fontSize: "600",
                                lineHeight: "600",
                                fontWeight: "semibold",
                                children: "Help & API"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionContent, {
                                title: gettingStarted.title,
                                desc: gettingStarted.desc
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                display: "flex",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                children: gettingStarted.content.map(function(cc, i) {
                                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, _objectSpread({}, cc), "cardKey".concat(i)));
                                })
                            })
                        ]
                    })
                }),
                migrationGuides && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "800",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionContent, {
                                    title: migrationGuides.title,
                                    desc: migrationGuides.desc
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    children: migrationGuides.content.map(function(link, i) {
                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GuideLink, _objectSpread({}, link), "guideLink".concat(i)));
                                    })
                                })
                            ]
                        })
                    ]
                }),
                clientLibraries && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "800",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionContent, {
                                    title: clientLibraries.title,
                                    desc: clientLibraries.desc
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    children: clientLibraries.content.map(function(library, i) {
                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Library, _objectSpread({}, library), "library".concat(i)));
                                    })
                                })
                            ]
                        })
                    ]
                }),
                help && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            px: "800",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionContent, {
                                    title: help.title,
                                    desc: help.desc,
                                    desc2: help.desc2
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    children: help.content.map(function(links, i) {
                                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HelpLink, _objectSpread({}, links), "helpLink".concat(i)));
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseHomePageContent);


/***/ }),

/***/ 44177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fg": function() { return /* binding */ StyledLink; },
/* harmony export */   "zK": function() { return /* binding */ StatusColorMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_ssr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33369);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18518);
/* harmony import */ var _sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6848);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _styled_system_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37947);
/* harmony import */ var _sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26581);
/* harmony import */ var _sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__);









function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  cursor: pointer;\n  overflow-wrap: anywhere;\n\n  &,\n  &:visited,\n  &:active {\n    text-decoration: none;\n    ",
        "\n  }\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  cursor: pointer;\n  &:hover {\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].a(_templateObject(), function(param) {
    var $active = param.$active, $level = param.$level;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        py: '200',
        pr: '700',
        pl: "calc(".concat(_sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__.tokens.spacing_500, " + ").concat(_sparkpost_design_tokens__WEBPACK_IMPORTED_MODULE_3__.tokens.spacing_200, " * ").concat($level, ")"),
        bg: $active ? 'blue.700' : 'transparent',
        color: $active ? 'white' : 'gray.900'
    });
}, function(param) {
    var $active = param.$active;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        bg: $active ? 'blue.700' : 'gray.200',
        color: $active ? 'white' : 'gray.900'
    });
});
var StatusColorMap = {
    none: 'green.700',
    minor: 'yellow.400',
    major: 'brand.orange',
    critical: 'red.700'
};
var BaseNavigation = function(props) {
    var _data = props.data, data = _data === void 0 ? [] : _data, title = props.title, titleLink = props.titleLink, children = props.children;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        width: [
            '100%',
            null,
            '260px'
        ],
        position: "sticky",
        top: "0",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                href: titleLink,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                        display: [
                            'none',
                            null,
                            'inline-block'
                        ],
                        fontSize: "200",
                        lineHeight: "200",
                        fontWeight: "semibold",
                        pl: "500",
                        children: title
                    })
                })
            }),
            data.map(function(item, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, _objectSpread({}, item), i);
            }),
            children
        ]
    }));
};
var getActiveUrl = function(location) {
    if (!location) {
        return '';
    }
    return location.pathname + location.hash;
};
var findActiveChild = function(items, activeUrl) {
    return items.find(function(item) {
        var hasDirectChild = item.link == activeUrl;
        if (!hasDirectChild && item.items) {
            return findActiveChild(item.items, activeUrl);
        }
        return hasDirectChild;
    });
};
var Chevron = function(props) {
    var expanded = props.expanded;
    return expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_7__/* .KeyboardArrowUp */ .Q6b, {
        size: 18
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox_icons__WEBPACK_IMPORTED_MODULE_7__/* .KeyboardArrowDown */ .WdC, {
        size: 18
    });
};
var StyledChevronWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu)(_templateObject1(), _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .styles.buttonReset */ .W2.buttonReset, function(param) {
    var $active = param.$active;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        color: $active ? 'white' : 'blue.700'
    });
}, function(param) {
    var $active = param.$active;
    return (0,_styled_system_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        color: $active ? 'white' : 'inherit'
    });
});
var Item = function(props) {
    var link = props.link, title = props.title, items = props.items, _level = props.level, level = _level === void 0 ? 0 : _level;
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), active = ref[0], setActive = ref[1];
    var ref1 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), expanded = ref1[0], setExpanded = ref1[1];
    var environment = (0,utils_ssr__WEBPACK_IMPORTED_MODULE_8__/* .getWindow */ .J)();
    var activeUrl = getActiveUrl(environment === null || environment === void 0 ? void 0 : environment.location);
    var hasActiveChild = items && findActiveChild(items, activeUrl);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var isExpanded = Boolean(hasActiveChild) || activeUrl === link || activeUrl.includes(link);
        var isActive = activeUrl === link;
        setExpanded(isExpanded);
        setActive(isActive);
    }, [
        link,
        activeUrl
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        fontSize: "200",
        lineHeight: "200",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                href: link,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledLink, {
                    $active: active,
                    $level: level,
                    children: title
                })
            }),
            items && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledChevronWrapper, {
                as: "button",
                position: "absolute",
                right: "400",
                top: "6px",
                width: "24px",
                height: "24px",
                onClick: function() {
                    return setExpanded(!expanded);
                },
                "aria-expanded": expanded,
                "aria-controls": "".concat(link, "__items"),
                $active: active,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .ScreenReaderOnly */ .uy, {
                        children: "Expand Menu"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Chevron, {
                        expanded: expanded
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                id: "".concat(link, "__items"),
                children: expanded && items && items.map(function(item, i) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, _objectSpread({
                        level: level + 1
                    }, item), i);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (BaseNavigation);


/***/ }),

/***/ 31277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18518);
/* harmony import */ var components_site_headerButtons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64847);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var _layoutWrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34109);
/* harmony import */ var _layoutInnerContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22545);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Layout = function(props) {
    var children = props.children, navigationComponent = props.navigationComponent;
    var ref = (0,_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .useDrawer */ .yT)(), getDrawerProps = ref.getDrawerProps, getActivatorProps = ref.getActivatorProps;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().asPath;
    var category = asPath.split('/')[1];
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layoutWrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer */ .dy, _objectSpread({}, getDrawerProps(), {
                position: "right",
                id: "mobile-menu",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer.Header */ .dy.Header, {
                        children: [
                            category === 'momentum' ? 'Momentum' : 'Support',
                            " Documentation"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer.Content */ .dy.Content, {
                        children: navigationComponent
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Drawer.Footer */ .dy.Footer, {
                        children: !props.hideDrawerButtons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_site_headerButtons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layoutInnerContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                getActivatorProps: getActivatorProps,
                hideDrawerButtons: props.hideDrawerButtons,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    display: "flex",
                    width: "100%",
                    bg: "white",
                    border: "400",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            flex: "0",
                            borderRight: "400",
                            display: [
                                'none',
                                null,
                                'block'
                            ],
                            children: navigationComponent
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sparkpost_matchbox__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                            py: "500",
                            flex: "1",
                            id: "main-content",
                            overflow: "hidden",
                            position: "relative",
                            children: children
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ })

}]);